import Vue from 'vue'
import Store from '../../store';

export default {
    getProduto(){
        if(Store.getters.ajustePlano) return Store.getters.ajustePlano;

        return Store.getters.ajusteTaxa;
    }
}